import {
  animate,
  animateChild,
  group,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  IToast,
  MessagingUtils,
  ToastCloseReason,
} from '@formunauts/shared/messaging/domain';
import { ToastMessageService } from '../../services/toast-message.service';
import { ToastComponent } from '../toast/toast.component';

/**
 * CSS class used for the component
 */
const COMPONENT_CLASS = 'toast-stack';

const fadeMessageAnimation = trigger('fadeMessageAnimation', [
  state('resting', style({ opacity: 1, transform: 'scale(1)' })),
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0)' }),
    group([
      // Start animating
      animate('0.2s'),
      // And we also want to play the child animation
      query('@timeoutTrigger', animateChild()),
    ]),
  ]),
  transition(':leave', [
    animate('0.2s', style({ opacity: 0, transform: 'scale(0)' })),
  ]),
]);

// TODO(architecture): Move to @fmnts/components.
/**
 * Component that displays a stack of toast messages
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-toast-stack',
  templateUrl: './toast-stack.component.html',
  styleUrls: ['./toast-stack.component.scss'],
  animations: [fadeMessageAnimation],
  imports: [ToastComponent, AsyncPipe],
})
export class ToastStackComponent {
  protected readonly componentClass = COMPONENT_CLASS;
  protected readonly toastMessageService = inject(ToastMessageService);
  /**
   * Stream of messages
   */
  public readonly messages$ = this.toastMessageService.messages$;

  /**
   * Function to be passed to angulars *ngFor `trackBy`
   */
  protected readonly trackMessage = MessagingUtils.trackMessageByKey<IToast>();

  public onToastClosed(toast: IToast, event: ToastCloseReason): void {
    this.toastMessageService.close(toast.key);

    if (toast?.actions?.closed) {
      toast.actions.closed(event);
    }
  }

  public onToastAction(toast: IToast, event: string): void {
    if (toast?.actions?.action) {
      toast.actions.action(event);
    }
  }
}
